import React, { useState } from 'react';
import { useNotify, useRecordContext } from 'react-admin';
import get from 'lodash/get';
import {
  Typography,
  IconButton,
  Box,
  Tooltip
} from '@material-ui/core';
import { Visibility, Check, FileCopyOutlined } from '@material-ui/icons';
import { httpClient } from 'api/httpClient';
import { useCopyFeedback } from './useCopyFeedback';
import { useNotifyError } from 'utils/notifiers/useNotifyError';


const markTokenAsViewed = async (id, resource, token_viewed_field) => {
	return await httpClient(`/${resource}/${id}`, {
		method: 'PATCH',
		body: JSON.stringify({ [token_viewed_field]: true }),
	});
};

const _Mask = '*';
const MASK_LENGTH = 32;

const getMask = (length = MASK_LENGTH, mask = _Mask) => mask.repeat(length).slice(0, 64);

export const MaskedTokenFieldOnce = ({
	source,
	emptyText = null,
	resource,
	viewedField,
	idField = 'id',
	revealNotice,
	...rest
}) => {
	const record = useRecordContext();
	const notifyError = useNotifyError();
	const notify = useNotify();
	const { copied, copy } = useCopyFeedback();

	const [revealedToken, setRevealedToken] = useState(null);

	if (!record) return null;

	const viewed = record[viewedField];
	const id = get(record, idField);

	const handleReveal = async () => {
		if (viewed || revealedToken) return;
		try {
			const { json } = await markTokenAsViewed(id, resource, viewedField);
			const token = get(json, source);
			if (!token) return;
			setRevealedToken(token);
			notify(revealNotice, 'info');
		} catch (error) {
			notifyError(error);
		}
	};

	const handleCopy = () => copy(revealedToken);

	const isTokenEmpty = get(record, source) === '';
	const displayValue = isTokenEmpty ? emptyText : revealedToken || getMask();

	return (
		<Box display="flex" alignItems="center" {...rest}>
			<Typography variant="body2" style={{ marginRight: 8 }}>
				{displayValue}
			</Typography>

			{!isTokenEmpty && !viewed && !revealedToken && (
				<Tooltip title="Reveal token">
					<IconButton size="small" onClick={handleReveal}>
					<Visibility fontSize="small" />
					</IconButton>
				</Tooltip>
			)}

			{revealedToken && (
				<Tooltip title={copied ? 'Copied!' : 'Copy token'}>
					<IconButton size="small" onClick={handleCopy}>
					{copied ? <Check fontSize="small" /> : <FileCopyOutlined fontSize="small" />}
					</IconButton>
				</Tooltip>
			)}
		</Box>
	);
};
